module.exports = __webpack_public_path__ + "static/media/six-point-dice.1d1ab14b.svg";